import { css, StyleSheet } from 'aphrodite'
import cn from 'classnames'
import React from 'react'
import Layout from '../components/Layout'
import { useModal } from '../hooks/modal'
import { PermissionDenied } from '../components/PermissionDenied'
import Button from '../components/common/Button'
import TaskCreate from '../components/TaskCreate'
import { useLoad } from '../hooks/request'
import { TASK_LIST } from '../urls'
import TaskFilter from '../components/TaskFilter'
import Table from '../components/common/Table'
import TaskItem from '../components/TaskItem'
import { useQueryParams } from '../hooks/queryString'
import { checkPermission as cp } from '../utils/auth'

export default function Task() {
    const params = useQueryParams()
    const tasks = useLoad({ url: TASK_LIST, params })

    const [showCreateModal, hideCreateModal] = useModal(
        <TaskCreate onSuccess={() => {
            hideCreateModal()
            tasks.request()
        }} onCancel={() => hideCreateModal()} />,
    )

    if (!cp('task.view_task')) {
        return <PermissionDenied />
    }

    return (
        <Layout>
            <div className={cn('columns', css(styles.heading))}>
                <div className="column">
                    <span className="is-size-4">Задачи</span>&nbsp; &nbsp;
                </div>

                <div className="column is-narrow">
                    {cp('task.add_task') ? (
                        <Button
                            onClick={showCreateModal}
                            text="Добавить"
                            icon="ion-md-add"
                            className="is-pulled-right is-link is-outlined" />
                    ) : null}
                </div>
            </div>

            <TaskFilter /><br />

            { tasks.response ? (
                <Table
                    loading={tasks.loading}
                    totalCount={tasks.response ? tasks.response.count : 0}
                    columns={{
                        title: 'Заголовок',
                        assigned: 'Ответственный',
                        dueTime: 'Срок',
                        status: 'Статус',
                        actions: '',
                    }}
                    items={tasks.response ? tasks.response.results : []}
                    renderItem={(item) => (
                        <TaskItem onDelete={tasks.request} onUpdate={tasks.request} key={item.id} item={item} />
                    )} />
            ) : null}

            <br />
        </Layout>
    )
}

const styles = StyleSheet.create({
    heading: {
        marginBottom: 0,
    },
})
